import clsx from 'clsx';
import React from 'react';

import { TextButton } from '@components/Button/variants';
import IconArrowDown from '@components/Images/Rebranding/IconArrowDown';
import IconClose from '@components/Images/Rebranding/IconClose';
import useEventTracking from '@hooks/useEventTracking';
import { titv_path } from '@routes';
import { click } from '@tracking';
import { ClickTarget } from '@tracking';

import { TITV_LIVE_NOW } from './constants';
import styles from './styles.module.scss';

interface HeaderProps {
  isMinimized: boolean;
  toggleMinimized: () => void;
  handleClose: () => void;
}

const Header = ({ isMinimized, toggleMinimized, handleClose }: HeaderProps) => {
  const { trackEvent } = useEventTracking();
  return (
    <header className="flex w-full items-center justify-between bg-grayscale-charcoal px-6 py-4 sm:max-w-[388px] dark:bg-black">
      <a href={titv_path()} className="flex items-center font-suisse-intl text-button-xs font-bold">
        <span
          className={clsx(
            styles['animate-slow-blink'],
            'mr-4 block h-8 w-8 rounded-full bg-red-500'
          )}
          onClickCapture={() =>
            trackEvent(click({ clickTarget: ClickTarget.TITV, clickText: TITV_LIVE_NOW }))
          }
        />
        {TITV_LIVE_NOW}
      </a>
      <div className="flex items-center gap-12 fill-grayscale-beige stroke-white text-grayscale-beige">
        <TextButton
          as="button"
          onClick={toggleMinimized}
          className="p-0 text-white"
          aria-label="Toggle minimized"
        >
          <IconArrowDown
            className={clsx('block w-12 cursor-pointer stroke-1', { 'rotate-180': isMinimized })}
          />
        </TextButton>
        <TextButton
          as="button"
          onClick={handleClose}
          className="p-0 text-white hover:!text-white"
          aria-label="Close"
        >
          <IconClose className="block w-12 rotate-180 cursor-pointer stroke-2" />
        </TextButton>
      </div>
    </header>
  );
};

export default Header;
